export default __webpack_public_path__ + "static/media/mamut_background_xl2.dc487548.jpg";